import productModule from "./productModule"
import productView from "./productView.html"

productModule.config(["editionServiceProvider", (editionServiceProvider) =>{
    editionServiceProvider.registerEdition("product", productView, "productController")
}])